<template>

    <div id="presentation-package">

        <section class="heading-section" data-aos="fade-in">
            <div class="mx-xl-4 py-2" style="display: flex">
                <div class="heading" style="padding: 0 15px;">
                    <a href="/vip-area" class="back"></a>
                    <div class="title">{{ t.__('Dodaj materiał do Pakietu Prezentacji') }}</div>
                </div>
                <div class="text-right d-flex align-items-center" style="padding: 0 15px;margin-left: auto">
                    <div class="slide-types" v-if="view === 'list'">
                        <div class="title">{{ t.__('Rodzaj materiału') }}</div>
                        <div class="type">
                            <div class="color presentation"></div>
                            <div class="name">{{ t.__('Prezentacja') }}</div>
                        </div>
                        <div class="type">
                            <div class="color video"></div>
                            <div class="name">{{ t.__('Film') }}</div>
                        </div>
                        <div class="type">
                            <div class="color mixed"></div>
                            <div class="name">{{ t.__('Mieszany') }}</div>
                        </div>
                    </div>
                    <div class="vip-small-icon"></div>
                </div>
            </div>
            <div class="mx-xl-5 buttons">
                <div class="button-change-view list-view" :class="{'active': view === 'list'}" @click="setView('list')">
                    <div class="icon"></div>
                    <div class="name">{{ t.__('Lista') }}</div>
                </div>
                <div class="button-change-view board-view" :class="{'active': view === 'board'}" @click="setView('board')">
                    <div class="icon"></div>
                    <div class="name">{{ t.__('Tablica') }}</div>
                </div>

                <div class="button-delete-wrapper">
                    <div class="button-add-set" @click="addPresentation">
                        <div class="name">{{ t.__('Dodaj') }}</div>
                        <div class="icon"></div>
                    </div>
                    <div class="button-delete" :class="{'disabled': selectedPresentations.length === 0}" @click="deleteElements">
                        <div class="name">{{ t.__('Usuń') }}</div>
                        <div class="icon"></div>
                    </div>
<!--                    <my-quizzes-delete-elements-hint></my-quizzes-delete-elements-hint>-->
                </div>
                <div class="button-order">
                    <b-dropdown variant="link" no-caret>
                        <template #button-content>
                            <div class="d-flex align-items-center">
                                <div class="name">{{ t.__('Sortuj według') }}</div>
                                <div class="icon"></div>
                            </div>
                        </template>
                        <b-dropdown-item v-for="sortType in sortTypes" :key="sortType.value" @click="selectedSortType = sortType.value" :active="selectedSortType === sortType.value">{{ sortType.text }}</b-dropdown-item>
                    </b-dropdown>

                </div>
                <div class="search-field">
                    <input type="text" :placeholder="t.__('Wyszukaj')" v-model="searchText">
                </div>
            </div>
        </section>

        <div class="row">
            <div class="col-9 content-column">

                <presentation-package-list-view :presentations="filteredPresentations" v-if="view === 'list'" :selected-sort-type="selectedSortType"></presentation-package-list-view>

                <presentation-package-board-view :presentations="filteredPresentations" v-if="view === 'board'" :selected-sort-type="selectedSortType"></presentation-package-board-view>

            </div>
            <div class="col-3 pt-4 synchronize-column">

                <synchronization-column></synchronization-column>

            </div>
        </div>

        <presentation-package-presentation-modal></presentation-package-presentation-modal>

        <presentation-package-delete-elements-modal></presentation-package-delete-elements-modal>

    </div>

</template>

<script>

export default {

    name: 'PresentationPackage',

    props: {
        presentationsInput: Array
    },

    data() {
        return {
            eventHub: window.eventHub,
            view: localStorage.getItem('presentationPackageViewMode') ? localStorage.getItem('presentationPackageViewMode') : 'list',
            sortTypes: [
                {
                    value: 'order',
                    text: t.__('Własnej kolejności')
                },
                {
                    value: 'name',
                    text: t.__('Nazwy')
                },
            ],
            selectedSortType: 'order',
            searchText: '',
            presentations: [],
            selectedPresentations: [],
        }
    },

    computed: {
        filteredPresentations() {

            if (this.presentations === undefined) {
                return [];
            }

            let presentations = [];

            if (this.searchText.length > 0) {

                this.presentations.forEach(presentation => {

                    // Check set name match
                    if (presentation.name.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1) {
                        presentations.push(presentation);
                    }

                });

            } else {
                this.presentations.forEach(presentation => {
                    presentations.push(presentation);
                });
            }

            switch (this.selectedSortType) {
                case 'order':
                    return presentations.sort(function(a, b) {
                        return (a.number_in_order < b.number_in_order) ? -1 : (a.number_in_order > b.number_in_order) ? 1 : 0;
                    });
                case 'name':
                    return presentations.sort(function(a, b) {
                        return a.name.localeCompare(b.name);
                    });
                default:
                    return presentations;
            }
        },
        hasProcessingVideos() {
            let hasProcessingVideos = false;
            this.presentations.some(presentation => {
                presentation.slides.some(slide => {
                   if (slide.processing === 1) {
                       hasProcessingVideos = true;
                   }
                   return hasProcessingVideos;
                });
                return hasProcessingVideos;
            });
            return hasProcessingVideos;
        },
    },

    beforeMount() {

        this.presentations = this.presentationsInput;

        this.eventHub.$on('presentation-package-order-changed' , (presentations) => {
            this.presentations = presentations;
            let orderData = presentations.map((presentation, index) => {
                return presentation.identifier;
            });
            axios.post('/presentation-package/update-order', {
                order_data: orderData
            })
                .then(response => {
                    this.eventHub.$emit('machine-synchronization-set-status-unsynchronized');
                })
                .catch(error => {
                    console.log(error);
                });
        });

        this.eventHub.$on('presentation-package-sync-selected' , (selectedPresentations) => {
            this.selectedPresentations = selectedPresentations;
        });

        this.eventHub.$on('presentation-package-delete-elements-start', () => {
            let data = {
                presentations: this.selectedPresentations
            };
            axios.post('/presentation-package/delete-presentations', data)
                .then(response => {
                    this.eventHub.$emit('presentation-package-update-presentations', response.data.presentations, response.data.synchronization_status, response.data.last_synchronization_date, response.data.total_disk_space, response.data.used_disk_space);
                    this.eventHub.$emit('presentation-package-delete-elements-complete');
                    this.eventHub.$emit('machine-synchronization-set-status-unsynchronized');
                    this.selectedPresentations = [];
                })
                .catch(error => {
                    console.log(error);
                });
        });

    },

    mounted() {

        this.eventHub.$on('presentation-package-update-presentations' , (presentations) => {
            this.presentations = presentations;
        });

        window.setInterval(() => {
            if (this.hasProcessingVideos) {
                axios.get('/presentation-package/get-presentations')
                    .then(response => {
                        this.eventHub.$emit('presentation-package-update-presentations', response.data.presentations);
                        this.eventHub.$emit('machine-synchronization-set-status-unsynchronized');
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }, 2000);

    },

    methods: {

        setView(view) {
            this.view = view;
            localStorage.setItem('presentationPackageViewMode', this.view);
        },

        addPresentation() {
            this.eventHub.$emit('presentation-package-add-presentation');
        },

        deleteElements() {
            if (this.selectedPresentations.length > 0) {
                this.eventHub.$emit('presentation-package-delete-elements');
            }
        },

    }

}
</script>

<style scoped>

</style>
